export const ENVIRONMENTAL_AGREEMENT_TYPE_FSC = 1;
export const ENVIRONMENTAL_AGREEMENT_TYPE_PEFC = 2;
export const ENVIRONMENTAL_AGREEMENT_STATUS_SIGNED = 1;